import createSvgIcon from '../Utils/CreateSvgIcon';

export const VideoReq = createSvgIcon(
  <path d="M14 19H5V5L19 5L19 14H21L21 5V3L19 3L5 3L3 3V5V19V21H5H14V19ZM10 16L16 12L10 8V16ZM17 19H15V17H17V15H19V17H21V19H19V21H17V19Z" />,
  'VideoReq',
);
